module.exports = __webpack_public_path__ + "img/register.96ee1e91.png";